export default __webpack_public_path__ + "static/media/8fb56942d001ff5ee1ebea133b5b51621579271964271.a695b4f4.webp";